module.exports = "/images/gm.svg?37b1bc63aed41d5c5967eb66925ff045";